var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWasteout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.00018H22V26.0002H4V7.00018Z",
    fill: "#0679CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.0002H26V26.0002H0V27.0002Z",
    fill: "#012946"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.00018L13.5 26.0002L14.5 26.0002L14.5 7.00018L13.5 7.00018Z",
    fill: "#012946"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.00018L11 26.0002L12 26.0002L12 7.00018L11 7.00018Z",
    fill: "#012946"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.00018C22 6.08093 21.7672 5.17068 21.3149 4.3214C20.8626 3.47212 20.1997 2.70044 19.364 2.05043C18.5282 1.40042 17.5361 0.884809 16.4442 0.533026C15.3522 0.181243 14.1819 0.000182629 13 0.000182629C11.8181 0.000182629 10.6478 0.181243 9.55585 0.533026C8.46392 0.884809 7.47177 1.40043 6.63604 2.05044C5.80031 2.70045 5.13738 3.47212 4.68508 4.3214C4.23279 5.17068 4 6.08093 4 7.00018L13 7.00018H22Z",
    fill: "#012946"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.0002H14.5V11.0002H11V10.0002Z",
    fill: "#012946"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.0002H14.5V21.0002H11V20.0002Z",
    fill: "#012946"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5002H14.5V12.5002H11V11.5002Z",
    fill: "#012946"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21.5002H14.5V22.5002H11V21.5002Z",
    fill: "#012946"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3.00018C20.5 3.82861 19.1046 2.50018 18 2.50018C16.8954 2.50018 16.5 2.50018 16 2.00018C15.5 1.00018 15.8955 0.500184 17 0.500184C18.1046 0.500184 20.5 2.17176 20.5 3.00018Z",
    fill: "#53A4DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteout);
export default __webpack_public_path__ + "static/media/wasteout.41bc6be6274ac0ce87b463fe7acf7b52.svg";
export { ForwardRef as ReactComponent };